export default __webpack_public_path__ + "static/media/nibud.409a9258.png";